import React from 'react';
import { Button, Result } from 'antd';
import { useHistory } from 'react-router-dom';

const NotFound = () => {
  const history = useHistory();
  return (
    <Result
      status="404"
      title="404"
      subTitle="La página contable solicitada no existe."
      extra={<Button type="primary" onClick={() => history.push('/')}>Volver al Inicio</Button>}
    />
  );
};

export default NotFound;
